module.exports = __webpack_public_path__ + "img/HOME_INNS.7cbcb465.png";